/*
 * heilys® – Standfuß-Auswahl, Kombi-Deal-Leiste und Überraschung
 * Gehört zu snippets/heilys-stand-picker.liquid und snippets/heilys-cart-extras.liquid
 */
(function () {
  'use strict';
  if (window.hyExtrasInit) return;
  window.hyExtrasInit = true;

  var GIFT_ATTRIBUTE = 'Geschenk beilegen';
  var GIFT_RULES = [
    { needs: [['heilys-rotlichttherapie-ultra']], gift: 'FaceMask 2.0 (zu FullBody Max)' },
    { needs: [['heilys®-rotlichttherapie-opti']], gift: 'Gen20 ToGo (zu FullBody Duo)' },
    { needs: [['heilys-rotlichtlampe-gen300', 'heilys®-gen300-black'], ['heilys®-flexistand-l']], gift: 'PowerDot (zu Gen300 + FlexiStand)' }
  ];

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  // Ausweichlösung: Warenkorb-Inhalt selbst neu laden, falls das Theme nicht reagiert
  function renderCartManually() {
    return fetch(window.location.pathname + '?section_id=api-cart-items')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pairs = [
          ['[data-api-line-items]', '[data-items-holder]'],
          ['[data-api-upsell-items]', '[data-pair-products-holder]'],
          ['[data-api-cart-price]', '[data-cart-price-holder]']
        ];
        pairs.forEach(function (p) {
          var src = doc.querySelector(p[0]);
          if (!src) return;
          document.querySelectorAll(p[1]).forEach(function (target) { target.innerHTML = src.innerHTML; });
        });
      })
      .catch(function () {});
  }

  function itemsSnapshot() {
    var holder = document.querySelector('[data-items-holder]');
    return holder ? holder.innerHTML : '';
  }

  function refreshCart() {
    var before = itemsSnapshot();
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    setTimeout(function () {
      if (itemsSnapshot() === before) renderCartManually();
    }, 1200);
  }

  function formatMoney(cents) {
    try {
      if (window.theme && typeof window.theme.formatMoney === 'function' && window.theme.moneyFormat) {
        return window.theme.formatMoney(cents, window.theme.moneyFormat);
      }
    } catch (e) {}
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
  }

  /* ---------- Standfuß-Auswahl auf der Produktseite ---------- */

  function selectedStand(box) {
    var main = box.querySelector('input[name^="hy-stand-"]:checked');
    if (!main || !main.value) return null;
    if (main.value === 'expand') {
      var sub = box.querySelector('input[name^="hy-expand-"]:checked');
      return sub ? { id: sub.value, price: Number(sub.dataset.price || 0), flag: '' } : null;
    }
    return { id: main.value, price: Number(main.dataset.price || 0), flag: main.dataset.flag || '' };
  }

  function updateBox(box) {
    var main = box.querySelector('input[name^="hy-stand-"]:checked');
    var expand = box.querySelector('[data-hy-expand]');
    if (expand) expand.hidden = !(main && main.value === 'expand');

    var stand = selectedStand(box);
    var note = box.querySelector('[data-hy-gift-note]');
    if (note) note.hidden = !!(stand && stand.flag === 'flexi');

    if (!box.hasAttribute('data-has-stands')) return;
    var form = box.closest('form');
    var priceEl = form && form.querySelector('[data-add-to-cart] [data-product-price]');
    if (priceEl) {
      var total = Number(box.dataset.basePrice || 0) + (stand ? stand.price : 0);
      priceEl.innerHTML = formatMoney(total);
    }
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-hy-stand]');
    if (box) updateBox(box);
  });

  // Vor dem Panel den Standfuß in den Warenkorb legen
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var box = form.querySelector('[data-hy-stand][data-has-stands]');
    if (!box) return;
    if (form.dataset.hyPass === '1') {
      delete form.dataset.hyPass;
      return;
    }
    var stand = selectedStand(box);
    if (!stand) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = e.submitter && e.submitter.form === form ? e.submitter : form.querySelector('[data-add-to-cart]');
    if (btn) btn.classList.add('is-loading');

    addItems([{ id: Number(stand.id), quantity: 1 }])
      .catch(function () {})
      .then(function () {
        if (btn) btn.classList.remove('is-loading');
        form.dataset.hyPass = '1';
        if (form.requestSubmit) {
          form.requestSubmit(btn || undefined);
        } else {
          form.submit();
        }
      });
  }, true);

  /* ---------- Kombi-Deal-Leiste im Warenkorb ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hy-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    addItems([{ id: Number(btn.getAttribute('data-hy-add')), quantity: 1 }])
      .then(function () {
        btn.textContent = 'Im Warenkorb';
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        refreshCart();
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  /* ---------- Überraschung: Hinweis für das Lager ---------- */

  function norm(handle) {
    try { return decodeURIComponent(handle || ''); } catch (e) { return handle || ''; }
  }

  var syncing = false;
  var syncAgain = false;

  function syncGift() {
    if (syncing) { syncAgain = true; return; }
    syncing = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var handles = (cart.items || []).map(function (i) { return norm(i.handle); });
        var gifts = GIFT_RULES.filter(function (rule) {
          return rule.needs.every(function (group) {
            return group.some(function (h) { return handles.indexOf(norm(h)) !== -1; });
          });
        }).map(function (rule) { return rule.gift; });
        var want = gifts.join(', ');
        var have = (cart.attributes && cart.attributes[GIFT_ATTRIBUTE]) || '';
        if (want === have) return null;
        var attrs = {};
        attrs[GIFT_ATTRIBUTE] = want;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        });
      })
      .catch(function () {})
      .then(function () {
        syncing = false;
        if (syncAgain) { syncAgain = false; syncGift(); }
      });
  }

  /* ---------- Einbindung ---------- */

  // Standfuß-Auswahl aus <template data-hy-stand-tpl> ins Kaufformular setzen
  function injectStandPicker() {
    var tpl = document.querySelector('template[data-hy-stand-tpl]');
    if (!tpl) return;
    var form = document.querySelector('product-info [data-product-form]') || document.querySelector('form[data-product-form]');
    if (!form || form.querySelector('[data-hy-stand]')) return;
    var node = tpl.content.firstElementChild;
    if (!node) return;
    var clone = node.cloneNode(true);
    var anchor = form.querySelector('.product__submit__holder');
    if (anchor) {
      anchor.parentNode.insertBefore(clone, anchor);
    } else {
      form.appendChild(clone);
    }
    updateBox(clone);
  }

  var syncTimer;
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncGift, 300);
  }

  function init() {
    injectStandPicker();
    document.querySelectorAll('[data-hy-stand]').forEach(updateBox);
    syncGift();

    // Kombi-Deal und Überraschung im Warenkorb rendert das Theme selbst
    // (snippets/cart-line-items.liquid). Hier nur: Standfuß-Auswahl nach
    // Neuaufbau wieder einsetzen und den Lager-Hinweis abgleichen.
    new MutationObserver(function (mutations) {
      injectStandPicker();
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t.closest && (t.closest('[data-items-holder]') || t.closest('[data-pair-products-holder]'))) {
          scheduleSync();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('theme:cart:refresh', scheduleSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
